class WCDrawer extends WCOutsideListener(WCDummy) {
  static get tag() {
    return "wc-drawer";
  }

  static get observedAttributes() {
    return ["open"];
  }

  constructor() {
    super({ tag: WCDrawer.tag, hasStylesheet: true });

    if (this.position) {
      this.classList.add(this.position);
    }

    this.append(this.appendStyles());
  }

  connectedCallback() {
    document
      .querySelector(this.trigger)
      .addEventListener("click", this.#handleOpen.bind(this));
    this.querySelector(".js-drawer-close").addEventListener(
      "click",
      this.#handleOpen.bind(this)
    );
  }

  disconnectedCallback() {
    document
      .querySelector(this.trigger)
      .removeEventListener("click", this.#handleOpen);
    this.querySelector(".js-drawer-close").removeEventListener(
      "click",
      this.#handleOpen
    );
  }

  attributeChangedCallback(name, oldValue, newValue) {
    let portal = document.querySelector("wc-portal");
    if (newValue === "") {
      this.overlay = document.createElement("wc-overlay");
      if (!portal) {
        portal = document.createElement("wc-portal");
        document.body.append(portal);
      }
      if (!portal.querySelector("wc-overlay")) {
        portal.append(this.overlay);
        this.addOutsideListener();
      }
    } else {
      document
        .querySelectorAll("wc-portal wc-overlay")
        .forEach((overlay) => overlay.remove());
      this.removeOutsideListener();
    }
  }

  outsideListenerCallback(e) {
    if (!e.target.closest(this.trigger)) {
      this.open = "";
    }
  }

  get trigger() {
    return this.getAttribute("trigger");
  }

  get position() {
    return this.getAttribute("position");
  }

  set open(value) {
    if (value) {
      this.setAttribute("open", "");
    } else {
      this.removeAttribute("open");
    }
  }

  #handleOpen(e) {
    e.preventDefault();
    if (e.currentTarget.classList.contains("js-drawer-close")) {
      this.open = "";
    } else {
      this.open = "open";
    }
  }
}

customElements.define(WCDrawer.tag, WCDrawer);
